import deziiign32 from './32/deziiign_fav.ico';
import deziiign192 from './192/deziiign_fav.png';
import deziiign512 from './512/deziiign_fav_512.png';
import dvadesign32 from './32/dvadesign.ico';
import dvadesign192 from './192/dvadesign.png';
import dvadesign512 from './512/dvadesign_512.png';
import geograffee32 from './32/geograffee_fav.ico';
import geograffee192 from './192/geograffee_fav.png';
import geograffee512 from './512/geograffee_fav_512.png';
import hse32 from './32/hse_fav.ico';
import hse192 from './192/hse_fav.png';
import hse512 from './512/hse_fav_512.png';
import at32 from './32/at_fav.ico';
import at192 from './192/at_fav.png';
import at512 from './512/at_fav_512.png';
import onlinesdesign32 from './32/ODS_favicon.ico';
import onlinesdesign192 from './192/ODS_favicon.png';
import onlinesdesign512 from './512/ODS_favicon_512.png';
import onlinesart32 from './32/oa_fav.ico';
import onlinesart192 from './192/oa_fav.png';
import onlinesart512 from './512/oa_fav_512.png';
import superpuper32 from "./32/superpuper.ico"
import superpuper192 from "./192/superpuper.png"
import superpuper512 from "./512/superpuper_512.png"
import dafes32 from "./32/dafes.ico";
import dafes192 from './192/dafes_192.png';
import dafes512 from './512/dafes_512.png';
import brnd32 from './32/brnd_fav.ico';
import brnd192 from './192/brnd_fav.png';
import brnd512 from './512/brnd_fav_512.png';
import mediiia32 from './32/mediiia_fav.ico';
import mediiia192 from './192/mediiia_fav.png';
import mediiia512 from './512/mediiia_fav_512.png';
import dumuseum32 from './32/dumuseum.ico';
import dumuseum192 from './192/dum_192.png';
import dumuseum512 from './512/dum_512.png';
import cgrave32 from './32/cgrave_fav.ico';
import cgrave192 from './192/cgrave_fav.png';
import cgrave512 from './512/cgrave_fav_512.png';
import gallllery32 from './32/gallllery_fav.ico';
import gallllery192 from './192/gallllery_fav.png';
import gallllery512 from './512/gallllery_fav512.png';
import portfolio32 from './32/portfolio_fav32.ico';
import portfolio192 from './192/portfolio_fav192.png';
import portfolio512 from './512/portfolio_fav512.png';
import kiiids32 from './32/kids_fav.ico';
import kiiids192 from './192/kids_fav192.png';
import kiiids512 from './512/kids_fav512.png';
import lpu32 from './32/lpu_fav.ico';
import lpu192 from './192/lpu_192.png';
import lpu512 from './512/lpu_512.png';
import continuum32 from './32/continuum.ico';
import continuum192 from './192/continuum_192.png';
import continuum512 from './512/continuum_512.png';
import greenward32 from  './32/Logo_zp_g_color.ico'
import greenward192 from  './192/Logo_zp_g_color_192.png'
import greenward512 from  './512/Logo_zp_g_color_512.png'
import adcr32 from  './32/adcr_fav_new.ico'
import adcr192 from  './192/adcr_192_new.png'
import adcr512 from  './512/adcr_512_new.png'
import monalisatravels32 from './32/monalisatravels.ico';
import monalisatravels192 from './192/monalisatravels.png';

const favicons = {
  lpu: {
    small: lpu32,
    medium: lpu192,
    large: lpu512,
  },
  dum: {
    small: dumuseum32,
    medium: dumuseum192,
    large: dumuseum512,
  },
  portfolio: {
    small: portfolio32,
    medium: portfolio192,
    large: portfolio512,
  },
  kiiids: {
    small: kiiids32,
    medium: kiiids192,
    large: kiiids512,
  },
  brnd: {
    small: brnd32,
    medium: brnd192,
    large: brnd512,
  },
  deziiign: {
    small: deziiign32,
    medium: deziiign192,
    large: deziiign512,
  },
  dvadesign: {
    small: dvadesign32,
    medium: dvadesign192,
    large: dvadesign512,
  },
  geograffee: {
    small: geograffee32,
    medium: geograffee192,
    large: geograffee512,
  },
  hse: {
    small: hse32,
    medium: hse192,
    large: hse512,
  },
  at: {
    small: at32,
    medium: at192,
    large: at512,
  },
  onlinesdesign: {
    small: onlinesdesign32,
    medium: onlinesdesign192,
    large: onlinesdesign512,
  },
  oa: {
    small: onlinesart32,
    medium: onlinesart192,
    large: onlinesart512,
  },
  superpuper: {
    small: superpuper32,
    medium: superpuper192,
    large: superpuper512,
  },
  cgrave: {
    small: cgrave32,
    medium: cgrave192,
    large: cgrave512,
  },
  dafes: {
    small: dafes32,
    medium: dafes192,
    large: dafes512,
  },
  mediiia: {
    small: mediiia32,
    medium: mediiia192,
    large: mediiia512,
  },
  gallllery: {
    small: gallllery32,
    medium: gallllery192,
    large: gallllery512,
  },
  continuum: {
    small: continuum32,
    medium: continuum192,
    large: continuum512,
  },
  greenward: {
    small: greenward32,
    medium: greenward192,
    large: greenward512,
  },
  adcr: {
    small: adcr32,
    medium: adcr192,
    large: adcr512,
  },
  monalisatravels: {
    small: monalisatravels32,
    medium: monalisatravels192,
    large: monalisatravels192,
  }
}

export default favicons;import deziiign32 from './32/deziiign_fav.ico';
import deziiign192 from './192/deziiign_fav.png';
import deziiign512 from './512/deziiign_fav_512.png';
import dvadesign32 from './32/dvadesign.ico';
import dvadesign192 from './192/dvadesign.png';
import dvadesign512 from './512/dvadesign_512.png';
import geograffee32 from './32/geograffee_fav.ico';
import geograffee192 from './192/geograffee_fav.png';
import geograffee512 from './512/geograffee_fav_512.png';
import hse32 from './32/hse_fav.ico';
import hse192 from './192/hse_fav.png';
import hse512 from './512/hse_fav_512.png';
import at32 from './32/at_fav.ico';
import at192 from './192/at_fav.png';
import at512 from './512/at_fav_512.png';
import onlinesdesign32 from './32/ODS_favicon.ico';
import onlinesdesign192 from './192/ODS_favicon.png';
import onlinesdesign512 from './512/ODS_favicon_512.png';
import onlinesart32 from './32/oa_fav.ico';
import onlinesart192 from './192/oa_fav.png';
import onlinesart512 from './512/oa_fav_512.png';
import superpuper32 from "./32/superpuper.ico"
import superpuper192 from "./192/superpuper.png"
import superpuper512 from "./512/superpuper_512.png"
import dafes32 from "./32/dafes.ico";
import dafes192 from './192/dafes_192.png';
import dafes512 from './512/dafes_512.png';
import brnd32 from './32/brnd_fav.ico';
import brnd192 from './192/brnd_fav.png';
import brnd512 from './512/brnd_fav_512.png';
import mediiia32 from './32/mediiia_fav.ico';
import mediiia192 from './192/mediiia_fav.png';
import mediiia512 from './512/mediiia_fav_512.png';
import dumuseum32 from './32/dumuseum.ico';
import dumuseum192 from './192/dum_192.png';
import dumuseum512 from './512/dum_512.png';
import cgrave32 from './32/cgrave_fav.ico';
import cgrave192 from './192/cgrave_fav.png';
import cgrave512 from './512/cgrave_fav_512.png';
import gallllery32 from './32/gallllery_fav.ico';
import gallllery192 from './192/gallllery_fav.png';
import gallllery512 from './512/gallllery_fav512.png';
import portfolio32 from './32/portfolio_fav32.ico';
import portfolio192 from './192/portfolio_fav192.png';
import portfolio512 from './512/portfolio_fav512.png';
import kiiids32 from './32/kids_fav.ico';
import kiiids192 from './192/kids_fav192.png';
import kiiids512 from './512/kids_fav512.png';
import lpu32 from './32/lpu_fav.ico';
import lpu192 from './192/lpu_192.png';
import lpu512 from './512/lpu_512.png';
import continuum32 from './32/continuum.ico';
import continuum192 from './192/continuum_192.png';
import continuum512 from './512/continuum_512.png';
import greenward32 from  './32/Logo_zp_g_color.ico'
import greenward192 from  './192/Logo_zp_g_color_192.png'
import greenward512 from  './512/Logo_zp_g_color_512.png'
import adcr32 from  './32/adcr_fav_new.ico'
import adcr192 from  './192/adcr_192_new.png'
import adcr512 from  './512/adcr_512_new.png'
import monalisatravels32 from './32/monalisatravels.ico';
import monalisatravels192 from './192/monalisatravels.png';

const favicons = {
  lpu: {
    small: lpu32,
    medium: lpu192,
    large: lpu512,
  },
  dum: {
    small: dumuseum32,
    medium: dumuseum192,
    large: dumuseum512,
  },
  portfolio: {
    small: portfolio32,
    medium: portfolio192,
    large: portfolio512,
  },
  kiiids: {
    small: kiiids32,
    medium: kiiids192,
    large: kiiids512,
  },
  brnd: {
    small: brnd32,
    medium: brnd192,
    large: brnd512,
  },
  deziiign: {
    small: deziiign32,
    medium: deziiign192,
    large: deziiign512,
  },
  dvadesign: {
    small: dvadesign32,
    medium: dvadesign192,
    large: dvadesign512,
  },
  geograffee: {
    small: geograffee32,
    medium: geograffee192,
    large: geograffee512,
  },
  hse: {
    small: hse32,
    medium: hse192,
    large: hse512,
  },
  at: {
    small: at32,
    medium: at192,
    large: at512,
  },
  onlinesdesign: {
    small: onlinesdesign32,
    medium: onlinesdesign192,
    large: onlinesdesign512,
  },
  oa: {
    small: onlinesart32,
    medium: onlinesart192,
    large: onlinesart512,
  },
  superpuper: {
    small: superpuper32,
    medium: superpuper192,
    large: superpuper512,
  },
  cgrave: {
    small: cgrave32,
    medium: cgrave192,
    large: cgrave512,
  },
  dafes: {
    small: dafes32,
    medium: dafes192,
    large: dafes512,
  },
  mediiia: {
    small: mediiia32,
    medium: mediiia192,
    large: mediiia512,
  },
  gallllery: {
    small: gallllery32,
    medium: gallllery192,
    large: gallllery512,
  },
  continuum: {
    small: continuum32,
    medium: continuum192,
    large: continuum512,
  },
  greenward: {
    small: greenward32,
    medium: greenward192,
    large: greenward512,
  },
  adcr: {
    small: adcr32,
    medium: adcr192,
    large: adcr512,
  },
  monalisatravels: {
    small: monalisatravels32,
    medium: monalisatravels192,
    large: monalisatravels192,
  }
}

export default favicons;